import axios from './axios.js'

export function getMembersList() {
    return axios.get('/apimock/getGoodsList')
}

export function getRouters() {
    return axios.get('/open/menu_list')
}

// 添加菜单
export function addMenu(data) {
    return axios.post('/menu/add', data)
}

// 菜单分页
export function menuPagination(data) {
    return axios.post('/menu/page', data)
}

// 菜单删除
export function delMenu(id) {
    return axios.get(`/menu/deleted?id=${id}`)
}

// 获取一二级菜单列表
export function getMenu() {
    return axios.get(`/menu/list_level`)
}

// 修改菜单列表
export function updateMenu(data) {
    return axios.post(`/menu/update`, data)
}


// WEBPACK FOOTER //
// ./src/api/testApi.js